import React from 'react';
import StepScrollBox from '../../StepScrollBox';

const links = [
  { to: 'CommonInfo', label: 'Общая информация' },
  { to: 'Contents', label: 'Содержание' },
  { to: 'Results', label: 'Результаты проекта' },
  { to: 'Indicators', label: 'Показатели' },
  { to: 'Budget', label: 'Бюджет' },
  { to: 'Participants', label: 'Команда управления' },
  { to: 'Participants2', label: 'Согласующие' },
];

export default function ProjectScrollBox() {
  return (
    <StepScrollBox links={links} />
  );
}
